  const BASE_URL = process.env.REACT_APP_BASE_URL

  // AUTH ENDPOINTS
  export const endpoints = {
    SENDOTP_API: BASE_URL + "/auth/sendotp",
    SIGNUP_API: BASE_URL + "/auth/signup",
    LOGIN_API: BASE_URL + "/auth/login",
    RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
    RESETPASSWORD_API: BASE_URL + "/auth/reset-password",
  }

  // PROFILE ENDPOINTS
  export const profileEndpoints = {
    GET_USER_DETAILS_API: BASE_URL + "/profile/getUserDetails",
    GET_USER_ENROLLED_COURSES_API: BASE_URL + "/profile/getEnrolledCourses",
    GET_INSTRUCTOR_DATA_API: BASE_URL + "/profile/instructorDashboard",
  }

 

  // CATAGORIES API
  export const categories = {
    CATEGORIES_API: BASE_URL + "/showAllCategories",
    CREATE_CATEGORY_API: BASE_URL + "/createCategory",
    DELETE_CATEGORY_API: BASE_URL + "/delete"
  }

  // CATALOG PAGE DATA
  export const catalogData = {
    CATALOGPAGEDATA_API: BASE_URL + "/course/getCategoryPageDetails",
  }
  // CONTACT-US API
  export const contactusEndpoint = {
    CONTACT_US_API: BASE_URL + "/contact",
    ALL_CONTACTS_API: BASE_URL + "/allcontact"
};
  // SETTINGS PAGE API
  export const settingsEndpoints = {
    UPDATE_DISPLAY_PICTURE_API: BASE_URL + "/profile/updateDisplayPicture",
    UPDATE_PROFILE_API: BASE_URL + "/profile/updateProfile",
    CHANGE_PASSWORD_API: BASE_URL + "/auth/changepassword",
    DELETE_PROFILE_API: BASE_URL + "/profile/deleteProfile",
  }

  // images create and show
  export const imageEndpoints = {
    CREATE_IMAGE_API: BASE_URL + "/images",
    GET_ALL_IMAGES_API: BASE_URL + "/images/allimage",
    GET_IMAGE_BY_ID_API: BASE_URL + "/images", 
    DELETE_IMAGE_API: BASE_URL + "/images", 
    UPDATE_IMAGE_API: BASE_URL + "/images", 
    GET_IMAGES_BY_CATEGORY_API: BASE_URL + "/category", 
};
  // images create and show
  export const gallaryEndpoints = {
    CREATE_GALLERY_API: BASE_URL + "/gallery/create",
    GET_ALL_GALLERIES_API: BASE_URL + "/gallery/all",
    GET_IMAGE_BY_ID_API: (id) => `${BASE_URL}/gallery/${id}`, 
    DELETE_IMAGE_API: (id) => `${BASE_URL}/gallery/${id}`, 
    UPDATE_IMAGE_API: (id) => `${BASE_URL}/gallery/${id}`, 
};
